import { render } from "./BatteryChart.vue?vue&type=template&id=40cb9d4a"
import script from "./BatteryChart.vue?vue&type=script&lang=js"
export * from "./BatteryChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__